module.exports={Earlier:"EARLIER",New:"NEW",NoAnnouncements:"You have no announcements"};